import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import FAQ from './FAQ';
import { useLocale } from '../../localization/LocaleContext';

export default function FAQMain(){
  const { t } = useLocale();
  useEffect(() => {
    document.title = t('meta.faqsTitle');
}, [t]);
const[loader, SetLoader] = useState(false)
    useEffect(() =>
    setTimeout(() =>{
        SetLoader(true)
    },1500)[loader]  
    )
    if (!loader) {
        return <Loader/>;
    }
  return(
      <Fragment>
      <FAQ/>
      <Footer/>
      </Fragment>
  )
}
